
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","height":"100%","viewBox":"0 0 235.72 313.84","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"XMLID_2_"}},[_c('path',{staticClass:"st0",attrs:{"d":"M235.65 190.09h-35.41c.08 1.24.12 2.44.12 3.63 0 52.35-42.83 84.77-82.5 84.77s-82.5-32.41-82.5-84.77c0-1.19.04-2.39.12-3.63H.07c-.05 1.21-.07 2.42-.07 3.63 0 72.07 58.93 120.12 117.86 120.12s117.86-48.05 117.86-120.12c0-1.21-.02-2.42-.07-3.63zM117.86 44.91l25.26 34.06h44.56C155.07 34.13 117.86 0 117.86 0S80.65 34.13 48.04 78.97H92.6l25.26-34.06z"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"117.86","cy":"135.28","r":"23.57"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"188.58","cy":"135.28","r":"23.57"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"47.14","cy":"135.28","r":"23.57"}})])])
          )
        }
      }
    